<app-dialog-header [title]="title" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content class="p-24">
    <div *ngIf="isCertificateMgmtFeatureEnabled">
        <app-providers-all-list
            [certificationProvidersTotalCount$]="certificationProvidersTotalCount$"
            [userIds$]="userIds$"
            [allUser$]="allUser$"
            [allUserTotalCount$]="allUserTotalCount$"
            [selectedCertificationIds$]="selectedCertificationIds$"
            [displayedColumns]="displayedColumns"
            [canUserManageCertificates]="true"
            [parentType]="parentType"
            [teamId]="team?.id"
            [subteamCount]="team?.subteamCount"
            [isTrackSubTeamProgressActive]="isTrackSubTeamProgressActive"
            [userId]="userId"
            [sessionStorageListPageSize]="'teamCertificatesListPageSize'"
        ></app-providers-all-list>
    </div>

    <div class="pb-16" *ngIf="(isGradebookFeatureEnabled || isCertificateOfAttendanceFeatureEnabled) && parentType === ParentType.TeamMember">
        <app-user-course-certificates-list
            [userCourseCertificates$]="userCourseCertificates$"
            [userCourseCertificatesTotalCount$]="userCourseCertificatesTotalCount$"
            [userId]="userId"
            [canNavigateToModule]="isCurrentUserTenantAdmin"
            (navigatedToModule)="dialogRef.close(false)"
        ></app-user-course-certificates-list>
    </div>
</div>
